module.exports = __webpack_public_path__ + "static/media/madrassa1.88cdc492.webp";